import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Box
} from '@mui/material';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import hostService from '../services/hostService';
import { toast } from 'react-toastify';

const UpdateMaxMemberDialog = ({ open, onClose, host, onUpdateSuccess }) => {
    const formik = useFormik({
        initialValues: {
            maxMember: host?.maxMember || 5,
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            maxMember: Yup.number()
                .required('Vui lòng nhập số lượng')
                .min(1, 'Tối thiểu 1 thành viên')
                .integer('Phải là số nguyên'),
        }),
        onSubmit: async (values) => {
            try {
                await hostService.updateHost(host.id, { maxMember: values.maxMember });
                toast.success('Cập nhật giới hạn thành viên thành công');
                onUpdateSuccess();
                onClose();
            } catch (error) {
                toast.error('Cập nhật thất bại: ' + (error.response?.data?.message || error.message));
            }
        },
    });

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Cập nhật giới hạn thành viên</DialogTitle>
            <form onSubmit={formik.handleSubmit}>
                <DialogContent>
                    <Box sx={{ pt: 1 }}>
                        <TextField
                            fullWidth
                            id="maxMember"
                            name="maxMember"
                            label="Số lượng thành viên tối đa"
                            type="number"
                            value={formik.values.maxMember}
                            onChange={formik.handleChange}
                            error={formik.touched.maxMember && Boolean(formik.errors.maxMember)}
                            helperText={formik.touched.maxMember && formik.errors.maxMember}
                        />
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose} color="inherit">
                        Hủy
                    </Button>
                    <Button type="submit" variant="contained" color="primary">
                        Cập nhật
                    </Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};

export default UpdateMaxMemberDialog;
